import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
const RouteContext = React.createContext();

export function useForReRoute() {
  return useContext(RouteContext);
}

//main function
export function ReRoute({ children }) {
  const [ledgerIdTransaction, setledgerIdTransaction] = useState();
  const [ledgerDateRange, setLedgerDateRange] = useState(null);
  const [AccountsIdTransaction, setAccountsIdTransaction] = useState();
  const [bankAccountID, setbankAccountID] = useState();
  const [checkedEntry, setcheckedEntry] = useState();
  const [journalsIdTransaction, setjournalsIdTransaction] = useState();

  const historyPageRoute = useHistory();
  const historyPageRouteToAccounts = useHistory();
  const historyPageRouteToJournals = useHistory();
  const historyPageRouteToPPE = useHistory();
  const historyPageRouteToBankUpdate = useHistory();
  const historyPageRouteToIncomeStatement = useHistory();

  const [incomeStatementDateRange, setIncomeStatementDateRange] =
    useState(null);
  function reRouteTBToLedger(id, dateRange = null) {
    // console.log(id);
    setledgerIdTransaction(id);
    if (dateRange) {
      setLedgerDateRange(dateRange);
    } else {
      setLedgerDateRange(null);
    }
    const accountQuery = id
      ? `?ledgerIdTransaction=${encodeURIComponent(String(id))}`
      : "";
    historyPageRoute.push(`/Ledger${accountQuery}`);
  }
  function reRouteTBToOpeningBalances(id) {
    // id may be account identifier or account name; store temporarily and navigate
    setledgerIdTransaction(id);
    historyPageRoute.push("/OpeningBalances");
  }
  // route to Ledger first, then from Ledger the app can redirect to OpeningBalances
  const [openOpeningBalancesTarget, setOpenOpeningBalancesTarget] = useState();
  function reRouteTBToLedgerThenOpeningBalances(id) {
    setOpenOpeningBalancesTarget(id);
    reRouteTBToLedger(id);
  }
  function reRouteTBToBankOpeningBalance(id) {
    // console.log(id);
    setledgerIdTransaction(id);
    historyPageRoute.push("/bankUpdate");
  }

  function reRouteToPPE() {
    historyPageRouteToPPE.push("/notes");
  }

  function reRouteToIncomeStatement(dateRange = null) {
    if (dateRange) {
      setIncomeStatementDateRange(dateRange);
    } else {
      setIncomeStatementDateRange(null);
    }
    historyPageRouteToIncomeStatement.push("/soci");
  }
  function reRouteLedgerToAccounts(
    id,
    journalOrAccounts,
    journalKey,
    bankAccountIDVal,
    checkedEntryVal,
    accountName = "",
    openingBalance = false,
  ) {
    // If it's a journal, route to journals
    if (journalOrAccounts === "journaltrue") {
      setjournalsIdTransaction(journalKey);
      historyPageRouteToJournals.push("/journals");
      return;
    }

    // If this transaction is an opening balance, route to OpeningBalances
    if (openingBalance === true) {
      // ensure Ledger knows which account to filter
      setledgerIdTransaction(id);
      // navigate to OpeningBalances page
      historyPageRoute.push("/OpeningBalances");
      return;
    }

    // If accountName indicates special bank opening balance flow
    if (accountName === "Opening balance") {
      setbankAccountID(bankAccountIDVal);
      historyPageRouteToBankUpdate.push("/bankUpdate");
      return;
    }

    // Default: route to Accounts page
    setAccountsIdTransaction(id);
    setbankAccountID(bankAccountIDVal);
    setcheckedEntry(checkedEntryVal);
    historyPageRouteToAccounts.push("/Accounts");
  }

  function removeFilterAccountsPage() {
    setAccountsIdTransaction(false);
  }

  // value is an object that we pass as props to RouteContext.provider which provides theses object value props to all
  // its nested components, etc. the objects props are passed throughout our components.
  const value = {
    reRouteTBToLedger,
    reRouteTBToOpeningBalances,
    reRouteTBToLedgerThenOpeningBalances,
    reRouteToPPE,
    reRouteTBToBankOpeningBalance,
    reRouteToIncomeStatement,
    ledgerIdTransaction,
    setledgerIdTransaction,
    AccountsIdTransaction,
    bankAccountID,
    setbankAccountID,
    checkedEntry,
    setAccountsIdTransaction,
    reRouteLedgerToAccounts,
    journalsIdTransaction,
    setjournalsIdTransaction,
    removeFilterAccountsPage,
    openOpeningBalancesTarget,
    setOpenOpeningBalancesTarget,
    ledgerDateRange,
    setLedgerDateRange,
    incomeStatementDateRange,
    setIncomeStatementDateRange,
  };
  return (
    <RouteContext.Provider value={value}>{children}</RouteContext.Provider>
  );
}
